<template>
<div id="mirrorItemDetail" class="mirrorItemDetail" v-if="item !== null" :class="{ 'is-modal': isMirrorMenuModal }">
  <MirrorHeader title="ITEM DETAIL" />
  <h2 class="mirrorItemDetail__brand"><img :src="item.brandMainImage" :alt="item.brandName" /></h2>
  <div class="mirrorItemDetail__wrap">
    <swiper :options="swiperOption" class="mirrorItemDetail__wrap__swiper">
      <swiper-slide v-for="image in item.mainImage" :key="image" class="mirrorItemDetail__wrap__swiper__slide">
        <div class="mirrorItemDetail__wrap__swiper__slide__imgwrap"><img :src="image" :alt="item.name" /></div>
      </swiper-slide>
      <div class="mirrorItemDetail__wrap__swiper__prev swiper-button-prev" slot="button-prev">
        <img src="@/assets/images/mirror/commons/commons-slideLeft.svg" alt="left" />
      </div>
      <div class="mirrorItemDetail__wrap__swiper__next swiper-button-next" slot="button-next">
        <img src="@/assets/images/mirror/commons/commons-slideRight.svg" alt="right" />
      </div>
    </swiper>
    <router-link v-if="item.brandName === 'LONGCHAMP'" :to="{ name: 'mirror-custom', query: { id: id } }" class="mirrorItemDetail__wrap__startbtn">カラーを選ぶ</router-link>
    <router-link v-else :to="{ name: 'mirror-custom', query: { id: id } }" class="mirrorItemDetail__wrap__startbtn">この商品をカスタマイズ</router-link>

    <h3 class="mirrorItemDetail__wrap__name">{{ item.name }}</h3>
    <div v-if="item.brandName === 'LONGCHAMP'">
      <p class="mirrorItemDetail__wrap__price"></p>
    </div>
    <div v-else>
      <p class="mirrorItemDetail__wrap__price">¥ {{ basePartsPrice | formatPrice(item.tax) }} ~</p>
    </div>
    <p class="mirrorItemDetail__wrap__comment">※表示価格は、消費税を含んだ税込価格です。</p>
    <p class="mirrorItemDetail__wrap__comment">※価格は変更になる場合があります。</p>
    <p v-if="item.brandName === 'LONGCHAMP'" class="mirrorItemDetail__wrap__comment">※品切れの場合もございます。在庫状況は、店頭スタッフにお問い合わせくださいませ。</p>
    <p class="mirrorItemDetail__wrap__disc">{{ item.description }}</p>
    <div class="mirrorItemDetail__wrap__info">
      <dl v-for="info in item.informations" :key="info.infoLabel">
        <dt>{{ info.infoLabel }}</dt><dd v-html="info.infoValue"></dd>
      </dl>
      <dl v-if="(deliveryDate !== '')">
        <dt>お届け日</dt><dd>{{ deliveryDate }}</dd>
      </dl>
    </div>
  </div>
  <MirrorFooter />
  <router-link :to="{ name: 'mirror-item-type', params: { brandID: item.brandID } }" class="mirrorBackBtn">
    <img src="@/assets/images/mirror/commons/commons-backBtn.svg" alt="Back">
  </router-link>
  <div @click="isMirrorMenuModal = true" class="mirrorGlobalMenu">
    <img src="@/assets/images/mirror/commons/commons-menu.svg" alt="Menu">
  </div>
  <MirrorMenuModal
    v-if="isMirrorMenuModal"
    @closeMenu="isMirrorMenuModal = false" />
  <ScreenSaverModal
    v-if="isScreenSaver"
    @closeScreenSaver="isScreenSaver = false" />
</div>
</template>

<script>
import Vue from 'vue'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'

import MirrorHeader from '@/components/mirror/MirrorHeader'
import MirrorFooter from '@/components/mirror/MirrorFooter'
import MirrorMenuModal from '@/components/mirror/MirrorMenuModal'
import ScreenSaverModal from '@/components/mirror/ScreenSaverModal'
import ScreenSaver from '@/assets/class/ScreenSaver'
import customMgr from '@/modules/CustomManager'
import { getDeliveryDateString } from '@/modules/utilityFunctions'

Vue.use(VueAwesomeSwiper)

export default {
  mixins: [ScreenSaver],
  components: {
    MirrorHeader,
    MirrorFooter,
    MirrorMenuModal,
    ScreenSaverModal
  },
  beforeRouteEnter (to, from, next) {
    customMgr.getItem(
      String(to.params.id),
      'mirror'
    ).then((item) => {
      next(vm => vm.setItem(item))
    }).catch(() => {
      next('/mirror')
    })
  },
  props: {
    id: String
  },
  data () {
    return {
      item: null,
      deliveryDate: '',
      swiperOption: {
        watchOverflow: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      isMirrorMenuModal: false
    }
  },
  metaInfo: {
    meta: [
      { name: 'viewport', content: 'width=1080,user-scalable=no' }
    ]
  },
  computed: {
    basePartsPrice () {
      return this.item.parts.find(el => el.baseItem === true).selects[0].price
    }
  },
  methods: {
    setItem (item) {
      this.item = item
      const allParts = []
      this.item['parts'].forEach(element => {
        Array.prototype.push.apply(allParts, element['selects'])
      })
      this.deliveryDate = getDeliveryDateString(allParts) // 納期記述
    }
  }
}
</script>

<style lang="scss" scoped>
.mirrorItemDetail {
  &.is-modal {
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
  &__brand {
    @include headerBrandLogo;
  }
  &__wrap {
    padding: 50px 100px;
    &__swiper {
      &__slide {
        padding: 0 100px;
        &__imgwrap {
          padding: 0 50px;
          background-color: $right-gray;
        }
      }
      .swiper-button-prev,
      .swiper-container-rtl
      .swiper-button-next {
        background-image: none;
      }
      .swiper-button-next,
      .swiper-container-rtl
      .swiper-button-prev {
        background-image: none;
      }
      .swiper-button-prev,
      .swiper-button-next {
        width: 80px;
        height: 80px;
        margin-top: -40px;
      }
      .swiper-button-prev {
        left: 0;
      }
      .swiper-button-next {
        right: 0;
      }
    }
    &__startbtn {
      display: block;
      margin: 50px 0 0 0;
      padding: 35px 0;
      background-color: $blue;
      color: $base-white;
      text-align: center;
      font-size: 28px;
      position: relative;
      &::after {
        content: '';
        position: absolute;
        top: 50%;
        right: 20px;
        width: 28px;
        height: 28px;
        background: url('../../assets/images/mirror/itemDetail/itemDetail-arrow.svg') top left no-repeat;
        background-size: 28px 28px;
        margin-top: -14px;
      }
    }
    &__name {
      margin: 80px 0 0 0;
      font-size: 40px;
      font-weight: bold;
      line-height: 1.5;
    }
    &__price {
      margin: 20px 0 0 0;
      font-size: 40px;
      font-weight: bold;
      text-align: right;
      line-height: 1.5;
    }
    &__comment {
      margin: 10px 0 0 0;
      font-size: 15px;
      text-align: right;
    }
    &__disc {
      margin: 30px 0 0 0;
      padding: 0 0 30px 0;
      font-size: 24px;
      line-height: 1.5;
      border-bottom: 3px dotted $right-gray;
    }
    &__info {
      padding: 40px 0;
      dl {
        padding: 20px;
        font-size: 24px;
        line-height: 1.5;
        dt {
          font-weight: bold;
        }
        dd {
          margin: 10px 0 0 0;
        }
      }
    }
  }
  .mirrorBackBtn {
    @include mirrorBackBtn;
  }
  .mirrorGlobalMenu {
    @include mirrorMenuBtn;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/mirror/MirrorItemDetail.vue